module.exports = __webpack_public_path__ + "img/keyboard_G.4adb5e15.png";